export const SET_LOGINED = 'SET_LOGINED'

export const REMOVE_LOGINED = 'REMOVE_LOGINED'

export const SET_USER = 'SET_USER'

export const ADD_READED_MESSAGE = 'ADD_READED_MESSAGE'

export const REMOVE_UNREAD_MESSAGE = 'REMOVE_UNREAD_MESSAGE'

export const ADD_UNREAD_MESSAGE = 'ADD_UNREAD_MESSAGE'

export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS'

export const SET_REFERSH_OPTION = 'SET_REFERSH_OPTION'



// WEBPACK FOOTER //
// ./src/store/mutation-type.js